//TODO: DONE! add firebase configuration and export it
export const firebaseConfig = {
	apiKey: 'AIzaSyDEpZBezgNLlsT1KKkGTBhJ1iyvXjCRdmQ',
	authDomain: 'contact-app-5a270.firebaseapp.com',
	projectId: 'contact-app-5a270',
	storageBucket: 'contact-app-5a270.appspot.com',
	messagingSenderId: '635026972888',
	appId: '1:635026972888:web:82566c087be24f69bb37ad',
	measurementId: 'G-EXZCWYQRWN',
};

//image configuration
export const imageConfig = {
	quality: 0.2,
	maxWidth: 800,
	maxHeight: 600,
	autoRotate: true,
};
